// extracted by mini-css-extract-plugin
export default {"panel-wrapper":"VersionPanel_panel-wrapper__vtuoB"};